<section class="lt-md:hidden flex mr-4">
  <!-- Map View -->
  @if (pipeline?.pipeline_type !== 'dynamic' && hasPipelineMapEnabled$ | async) {
  <button [matTooltip]="'Map'" (click)="navigateTo('map')" mat-icon-button>
    <mat-icon [svgIcon]="'location_on'"></mat-icon>
  </button>
  }

  <!-- Grid View -->
  <button [matTooltip]="'Grid'" (click)="navigateTo('grid')" mat-icon-button>
    <mat-icon [svgIcon]="'grid_on'"></mat-icon>
  </button>

  <!-- Kanban View -->
  <button [matTooltip]="'Kanban'" (click)="navigateTo('kanban')" mat-icon-button>
    <mat-icon [svgIcon]="'view_agenda'"></mat-icon>
  </button>

  <!-- Table View -->
  <button [matTooltip]="'List'" (click)="navigateTo('list')" mat-icon-button>
    <mat-icon [svgIcon]="'reorder'"></mat-icon>
  </button>
</section>
